import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate, useNavigate } from 'react-router-dom';
import Home from './components/pages/Home';
import Login from './components/pages/Login';
import PasswordReset from './components/pages/PasswordReset';
import { loginUser } from './api/auth';

const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(!!sessionStorage.getItem('token'));
  const [userName, setUserName] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const storedName = sessionStorage.getItem('name');
    if (storedName) {
      setUserName(storedName);
    }
  }, []);

  const handleLogin = async (email: string, password: string) => {
    try {
      await loginUser(email, password);
      setIsAuthenticated(true); // Update the logged-in state
      navigate('/'); // Navigate after successful login
    } catch (error) {
      console.error('Login failed: ', error);
      throw error; // Re-throw the error to be handled by the caller
    }
  };
  
  const handleLogout = () => {
    sessionStorage.clear();
    setIsAuthenticated(false);
  };

  return (
    <>
      <div className="App">
        {isAuthenticated && 
          <nav style={{ backgroundColor: '#4A90E2', padding: '10px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, width: '100%', zIndex: 1000 }}>
            <div style={{ color: 'white', fontSize: '1.5em' }}>Quali-fi</div>
            <div style={{ display: 'flex', gap: '15px', alignItems: 'center' }}>
              <a href="/" style={{ color: 'white' }}>Home</a>
              <span style={{ color: 'white' }}>{userName}</span>
              <button onClick={handleLogout} style={{ backgroundColor: '#4A90E2', padding: '0', margin: '0', color: 'white', border: 'none', cursor: 'pointer' }}>Logout</button>
            </div>
          </nav>
        }

        <Routes>
          <Route path="/" element={isAuthenticated ? <Home onLogout={handleLogout} /> : <Navigate to="/login" />} />
          <Route path="/login" element={isAuthenticated ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} />
          {/* <Route path="/password-reset"  element={<PasswordReset onLogin={handleLogin} />} /> */}
          <Route path="*" element={<Navigate to={isAuthenticated ? "/" : "/login"} />} />
        </Routes>
      </div>
    </>
  );
}

const AppWrapper = () => (
  <Router>
    <App />
  </Router>
);
export default AppWrapper;
